const appInfo = {
    version: "0.1.3",
};

export default appInfo;